module.exports = __webpack_public_path__ + "img/1.34380ec6.png";